import React from "react"
import { graphql } from "gatsby"
import Helmet from "react-helmet"
import {
  Heading,
  LinkButton,
  PreStyledComponents,
  Theme
} from "@life-without-barriers/react-components"
import {
  MobileSkulkAnimation,
  DesktopSkulkAnimation
} from "../../components/error/Animation"
import HelpfulLinks from "../../components/error/HelpfulLinks"
import { Site } from "@life-without-barriers/gatsby-common"
import Layout from "../../components/error/Layout"
import Header from "../../components/error/Header"
import {
  ErrorCode,
  GradientBG
} from "../../components/error/PreStyledComponents"

interface Props {
  data: {
    site: Site
  }
}

const FourOFour = ({
  data: {
    site: { siteMetadata }
  }
}: Props) => {
  const { Container } = PreStyledComponents
  const { fosterCareThemeFull } = Theme
  return (
    <Layout theme={fosterCareThemeFull}>
      <div className="vh-100-l">
        <Helmet
          title={`404 | ${siteMetadata.title}`}
          meta={[
            {
              name: "description",
              content:
                "Life Without Barriers provide support for children, young people and families, people with disability, older people, people with mental illness, people who are homeless and refugees and asylum seekers."
            }
          ]}
        />
        <Header />
        <GradientBG className="relative overflow-hidden flow fr-l w-100 w-60-l">
          <ErrorCode className="error-code fw8">404</ErrorCode>
          <MobileSkulkAnimation />
          <DesktopSkulkAnimation />
        </GradientBG>

        <div className="w-40-l fl-l tc tl-l">
          <Container className="ph3 ph4-l pt3 pb4">
            <h1 className="ts-display-1 fw8 ma0 mt4-ns">Page Not Found</h1>
            <Heading
              className="ts-display-4 fw6 mt3 mt4-ns w-90-ns center mh0-l"
              size={2}
            >
              We can&apos;t seem to find the page you are looking for.
            </Heading>

            <LinkButton
              className="mt4 mt5-ns"
              to="/"
              title="Return to home page"
            >
              Return Home
            </LinkButton>
            <HelpfulLinks />
          </Container>
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query Four04Query {
    site {
      siteMetadata {
        title
      }
    }
  }
`

export default FourOFour
